// Layout.jsx
import React, { useState, useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import Sidebar, { SIDEBAR_WIDTH, SIDEBAR_COLLAPSED_WIDTH } from './Sidebar';
import Navbar from './Navbar';

export default function Layout() {
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);
  const [isMobile, setIsMobile] = useState(false);

  // Check if screen is mobile size
  useEffect(() => {
    const checkMobile = () => {
      const mobile = window.innerWidth <= 768;
      setIsMobile(mobile);
      // On mobile, sidebar should be closed by default
      if (mobile) {
        setIsSidebarOpen(false);
      }
    };

    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  // Calculate margin only for desktop, mobile uses overlay
  const getMainStyles = () => {
    if (isMobile) {
      // On mobile, main content takes full width, sidebar overlays
      return {
        flex: 1,
        marginLeft: 0,
        display: 'flex',
        flexDirection: 'column',
        width: '100%'
      };
    } else {
      // On desktop, adjust margin based on sidebar state
      const marginLeft = isSidebarOpen ? SIDEBAR_WIDTH : SIDEBAR_COLLAPSED_WIDTH;
      return {
        flex: 1,
        marginLeft: `${marginLeft}px`,
        transition: 'margin-left 0.3s ease',
        display: 'flex',
        flexDirection: 'column',
        width: `calc(100% - ${marginLeft}px)` // Ensure proper width calculation
      };
    }
  };

  return (
    <div style={{ display: 'flex', height: '100vh', overflow: 'hidden' }}>
      <Sidebar isSidebarOpen={isSidebarOpen} toggleSidebar={toggleSidebar} />
      
      {/* Mobile overlay when sidebar is open */}
      {isMobile && isSidebarOpen && (
        <div 
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            zIndex: 99
          }}
          onClick={toggleSidebar}
        />
      )}

      <main style={getMainStyles()}>
        <Navbar toggleSidebar={toggleSidebar} />
        <div style={{ 
          padding: 24, 
          overflowY: 'auto', 
          flex: 1,
          width: '100%',
          boxSizing: 'border-box'
        }}>
          <Outlet />
        </div>
      </main>
    </div>
  );
}